import { FC } from 'react';
import { useTrackPageView } from 'features/tracking';
import { LocalizedText } from 'shared/ui/localized-text';
import { EnterprisePortalLayout } from 'shared/ui/portal-layout';
import { StyledErrorPageContainer } from './styled';

export const ErrorPage: FC = () => {
    useTrackPageView('landing > error');

    return (
        <EnterprisePortalLayout>
            <StyledErrorPageContainer>
                <LocalizedText localizationKey="Feedback.FormModal.Error.Subject" type="H5" />
                <LocalizedText localizationKey="Errors.500InternalServerError" type="H6" />
            </StyledErrorPageContainer>
        </EnterprisePortalLayout>
    );
};
